export function formatCurrency(amount) {
    var formattedValue = parseFloat(amount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return formattedValue.replace(/\s/g, ' ');
}

export function formatCentsToReais(valueCents) {
    return formatCurrency(valueCents / 100);
}